module.exports = __webpack_public_path__ + "img/2.PC.ae63a4c7.jpg";